import GameCardUI from "./GameCardUI";
import card_back from "../../../images/gameplay_ui/cards/back/security_card_back.png";
import GameWindowHeader from "../GameWindowHeader";
import breakdown from "../../../images/gameplay_ui/icons/is_break_down.svg";
import brigades from "../../../images/gameplay_ui/icons/brigade_chips_icon.svg";
import cash from "../../../images/gameplay_ui/icons/cash_icon.svg";
import GameWindowBg from "../GameWindowBg";
import GameData from "../../../gameplay/model/GameData";
import CurrencyCard from "../GeneralCards/CurrencyCard";
import {MaxSecurityLevel} from "../../../gameplay/model/Balance";
import star_full from "../../../images/gameplay_ui/icons/star_full.svg";
import star_empty from "../../../images/gameplay_ui/icons/star_empty_ingame.svg";
import UtilsFunctions from "../../../utils/UtilsFunctions";
import "./SecurityGameCardUI.css";

export default class SecurityGameCardUI extends GameCardUI {
    fillStars(howMany) {
        let stars = [];
        for (let i = 1; i <= MaxSecurityLevel; i++){
            stars.push(<img alt={"star"} key={i} src={howMany >= i ? star_full : star_empty}/>)
        }
        return stars;
    }

    render() {
        this.cardBack = card_back;

        if (!this.props.card.isLucky) {
            let styleFront = {
                position: "absolute",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                left: "0px",
                top: "0px",
                width: `${this.cardWidth}px`,
                height: `${this.cardHeight}px`,
                transform: `scale(${this.state.frontWidth}, ${this.state.backHeight})`,
                background: "#F2F2F2",
                borderRadius: "3px"
            }

            let card = this.props.card;
            let stars = this.fillStars(GameData.CurrentGame.securityLevel);

            let content = <div className={"security-card"}>
                <div className="security-card__level">
                    {stars}
                </div>
                <div className="security-card__table">
                    {card.levelSecurityCardEffects.map((el, i) => <div key={i} className={"security-card__effects"}>
                        <div className="security-card__left side">
                            {this.fillStars(i+1)}
                        </div>
                        <div className="security-card__right side">
                            <div className="power">{el.powerChips}</div>
                            <div className="cash">
                                <img alt={"icon"} src={cash}/>
                                <span>{UtilsFunctions.toPrettyNumber(el.expenses)}</span>
                            </div>
                            <div className="brigades">
                                <img alt={"brigades"} src={brigades}/>
                                <span>{el.brigadeChips}</span>
                            </div>
                        </div>
                    </div>)}
                </div>
            </div>;

            let icon = <div className={"security-card__icon"}><CurrencyCard size={35} icon={breakdown}/></div>;

            this.contentCard =
                <div style={styleFront} onClick={this.hide.bind(this)}>
                    <GameWindowHeader colorStart={"#FFCC33"} colorEnd={"#F2994A"} currencyBlocks={icon}
                                      width={330} height={60} title={`Пут${card.pathIDs.length > 1 ? 'и' : 'ь'} №${card.pathIDs.join("-")}`} />
                    <GameWindowBg value={content} width={330} height={435} />
                </div>
        }

        return super.render();
    }
}
